import React from 'react';

function NewTabComponent() {
  // Recupera el parámetro 'ticker' de la URL
  const searchParams = new URLSearchParams(window.location.search);
  const ticker = searchParams.get('ticker');

  // Construye la URL del archivo PDF
  const pdfUrl = `/pdfs/${ticker}.pdf`; // Reemplaza esto con la ruta real de tu archivo PDF
  //const pdfUrl = "/pdfs/GOOG.pdf"
  console.log(pdfUrl)

  return (
    <iframe
  src={pdfUrl}
  title="Título Descriptivo del PDF"
  style={{
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100vh',
    border: 'none', // Elimina el borde
  }}
></iframe>
  );
}

// function NewTabComponent() {
//     // Utiliza el estado local para almacenar los datos del "card" seleccionado
//     const [data, setData] = useState({});
  
//     useEffect(() => {
//       // Recupera los parámetros de la URL
//       const searchParams = new URLSearchParams(window.location.search);
//       const ticker = searchParams.get('ticker'); // Obtiene el valor del parámetro 'ticker'
  
//       console.log("Ticker from URL:", ticker); // Agrega este log
  
//       // Aquí puedes buscar los datos del "card" correspondiente
//       // Puedes hacerlo utilizando el valor de 'ticker' para buscar en tu arreglo 'stocks'
//       // y obtener los datos específicos.
  
//       // Ejemplo: Buscar el elemento correspondiente en 'stocks' teniendo en cuenta las comillas dobles
//       const selectedCard = stocks.find((stock) => stock.ticker === ticker || stock.ticker === `"${ticker}"`);
      
//       console.log("Selected Card:", selectedCard); // Agrega este log
  
//       if (selectedCard) {
//         // Si se encontró el "card" correspondiente, elimina las comillas dobles y actualiza el estado local
//         const cleanTicker = selectedCard.ticker.replace(/"/g, ''); // Elimina las comillas dobles
//         console.log("Cleaned Ticker:", cleanTicker); // Agrega este log
//         setData({ ...selectedCard, ticker: cleanTicker });
//       } else {
//         // Si no se encontró el "card" correspondiente, puedes manejarlo como desees
//         console.log(`No se encontró información para el ticker: ${ticker}`);
//       }
//     }, []);
  
//     return (
//       <div>
//         <h1>Información del card seleccionado</h1>
//         <p>Ticker: {data.ticker}</p>
//         <Typography>{data.NetIncome}</Typography>
//         {/* Muestra otros datos del "card" aquí */}
//       </div>
//     );
//   }

export default NewTabComponent;
     